import _defineProperty from "/app/vetiver/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import clsx from 'clsx';
import React from 'react';
import { darken, lighten, makeStyles } from '@material-ui/core/styles';
import { capitalize } from '@material-ui/core/utils';
import { LinearProgress } from '@material-ui/core'; // ----------------------------------------------------------------------

var useStyles = makeStyles(function (theme) {
  var isLight = theme.palette.mode === 'light';

  var gradientDashed = function gradientDashed(color) {
    var getColor = isLight ? lighten(color, 0.62) : darken(color, 0.5);
    return "radial-gradient(".concat(getColor, " 0%, ").concat(getColor, "  16%, transparent 42%)");
  };

  var createStyle = function createStyle(color) {
    return {
      '& .MuiLinearProgress-bar': {
        backgroundColor: theme.palette[color].main
      },
      '&.MuiLinearProgress-indeterminate, &.MuiLinearProgress-determinate, & .MuiLinearProgress-bar2Buffer, &.MuiLinearProgress-query': {
        backgroundColor: isLight ? theme.palette[color].lighter : theme.palette[color].darker
      },
      '& .MuiLinearProgress-dashed': {
        backgroundImage: gradientDashed(theme.palette[color].main)
      }
    };
  };

  return {
    colorInfo: createStyle('info'),
    colorSuccess: createStyle('success'),
    colorWarning: createStyle('warning'),
    colorError: createStyle('error')
  };
});
export var MLinearProgress = function MLinearProgress(_a) {
  var className = _a.className,
      _a$color = _a.color,
      color = _a$color === void 0 ? 'primary' : _a$color,
      other = __rest(_a, ["className", "color"]);

  var classes = useStyles();

  if (color === 'primary' || color === 'secondary') {
    return React.createElement(LinearProgress, Object.assign({
      color: color,
      className: className
    }, other));
  }

  return React.createElement(LinearProgress, Object.assign({
    className: clsx(_defineProperty({}, classes["color".concat(capitalize(color))], color), className)
  }, other));
};